import { LabScene } from './scene.js'

const navToggle = document.querySelector('.nav-toggle')
const primaryNav = document.querySelector('.primary-nav')
const navBackdrop = document.querySelector('.nav-backdrop')

if (navToggle && primaryNav && navBackdrop) {
  const setNavigationOpen = (isOpen) => {
    document.body.classList.toggle('nav-open', isOpen)
    navToggle.setAttribute('aria-expanded', String(isOpen))
    primaryNav.setAttribute('aria-hidden', String(!isOpen))

    if (isOpen) {
      primaryNav.querySelector('a')?.focus()
    } else {
      navToggle.focus()
    }
  }

  navToggle.addEventListener('click', () => {
    setNavigationOpen(navToggle.getAttribute('aria-expanded') !== 'true')
  })

  navBackdrop.addEventListener('click', () => setNavigationOpen(false))
  primaryNav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setNavigationOpen(false))
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && navToggle.getAttribute('aria-expanded') === 'true') {
      setNavigationOpen(false)
    }
  })
}

// The hero console only exists on the front page — other templates skip three.js entirely.
const canvas = document.querySelector('#viewscreen')
if (canvas) {
  const scene = new LabScene(canvas)
  scene.start()

  const toggles = document.querySelectorAll('.toggle')
  toggles.forEach((btn, i) => {
    if (i < 4) btn.classList.add('on')
    btn.addEventListener('click', () => btn.classList.toggle('on'))
  })

  function fillBlinkyLights(id, count) {
    const el = document.querySelector(id)
    if (!el) return null
    const colors = ['#ff9900', '#33ffcc', '#33ccff', '#ff3b30', '#9966ff']
    for (let i = 0; i < count; i++) {
      const light = document.createElement('span')
      light.style.background = colors[i % colors.length]
      light.style.opacity = '0.25'
      el.appendChild(light)
    }
    return el
  }

  const leftLights = fillBlinkyLights('#blinky-left', 14)
  const rightLights = fillBlinkyLights('#blinky-right', 14)

  function randomBlink(container) {
    if (!container) return
    container.querySelectorAll('span').forEach((light) => {
      if (Math.random() < 0.35) {
        light.style.opacity = light.style.opacity === '1' ? '0.25' : '1'
      }
    })
  }
  setInterval(() => {
    randomBlink(leftLights)
    randomBlink(rightLights)
  }, 450)

  document.querySelectorAll('.gauge-needle').forEach((needle) => {
    needle.style.animationDuration = `${2 + Math.random() * 2}s`
  })

  const alertBtn = document.querySelector('#red-alert-btn')
  const scanStatus = document.querySelector('#scan-status')
  let alertActive = false

  alertBtn?.addEventListener('click', () => {
    alertActive = !alertActive
    document.body.classList.toggle('crisis-mode', alertActive)
    alertBtn.classList.toggle('active', alertActive)
    scene.setAlertMode(alertActive)
    if (scanStatus) {
      scanStatus.textContent = alertActive
        ? 'CRISIS MODE — URGENT REVIEW REQUIRED'
        : 'ANALYSING CASE FILE — REF #RL-7042'
    }
  })

  const engageBtn = document.querySelector('#engage-btn')
  engageBtn?.addEventListener('click', () => {
    scene.triggerWarp()
    if (scanStatus) scanStatus.textContent = 'PULLING CASE HISTORY…'
    document.querySelector('#briefing')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    setTimeout(() => {
      if (!alertActive && scanStatus) scanStatus.textContent = 'ANALYSING CASE FILE — REF #RL-7042'
    }, 2500)
  })
}

// Runs on every page: footer clock.
const clockEl = document.querySelector('#clock')
if (clockEl) {
  const updateClock = () => {
    clockEl.textContent = new Date().toLocaleTimeString('en-GB', { hour12: false })
  }
  updateClock()
  setInterval(updateClock, 1000)
}
